import { BaseError } from '@adornis/validation/errors/BaseError.js';

export class RegistrationWrongCodeError extends BaseError {
  static override _class = 'RegistrationWrongCodeError';

  public constructor(message: string) {
    super('RegistrationWrongCodeError: ' + message, { translationKey: 'REGISTRATION_WRONG_CODE_ERROR' });
  }
}
